import axios from 'axios'
const cache = {}

export const getShopifyPrice = async (shopifyVariantId) => {
  if (cache[shopifyVariantId]) return cache[shopifyVariantId]

  const shopifyPrice = await axios.get(`/api/products/reference/${shopifyVariantId}/shopify-price`)

  cache[shopifyVariantId] = shopifyPrice.data

  return shopifyPrice.data
}